import React, { useState, useEffect } from 'react';
import { TextField, Button } from '@material-ui/core';
import api from '../apiConfig';
import '../assets/styles/contacts.css';

/**
 * Props:
 * - setView: (optional) function to change view.
 * - addContact: (optional) function to add a new contact (fallback behavior).
 * - closeForm: function to close the modal/form.
 * - existingContact: if provided, the form is in "edit" mode.
 * - onSaveContact: if provided, this function is used to handle saving (create/update).
 */
function ContactForm({ setView, addContact, closeForm, existingContact, onSaveContact }) {
  const [formInputs, setFormInputs] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    clientResources: '',
    realtorId: '6552b44fd56a4b6eef501e53'
  });

  // Autofill the form when editing an existing contact.
  useEffect(() => {
    if (existingContact) {
      setFormInputs({
        firstName: existingContact.firstName || '',
        lastName: existingContact.lastName || '',
        phoneNumber: existingContact.phoneNumber || '',
        email: existingContact.email || '',
        clientResources: existingContact.clientResources || '',
        realtorId: existingContact.realtorId || '6552b44fd56a4b6eef501e53'
      });
    } else {
      setFormInputs({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        clientResources: '',
        realtorId: '6552b44fd56a4b6eef501e53'
      });
    }
  }, [existingContact]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const payload = { ...formInputs };

    // If onSaveContact is provided (as in our ContactsPage), use it.
    if (onSaveContact && typeof onSaveContact === 'function') {
      onSaveContact(payload);
    } else {
      // Fallback to original behavior if onSaveContact is not provided.
      if (existingContact) {
        api.put(`/clients/${existingContact.id}`, payload)
          .then((res) => {
            console.log('Updated contact:', res.data);
            if (addContact && typeof addContact === 'function') {
              addContact(res.data);
            }
            setFormInputs({
              firstName: '',
              lastName: '',
              phoneNumber: '',
              email: '',
              clientResources: '',
              realtorId: process.env.ADMIN_REALTOR_ID || '6552b44fd56a4b6eef501e53'
            });
            setView && setView('table');
            closeForm && closeForm();
          })
          .catch((error) => {
            console.error('Error updating contact:', error);
            if (error.response && error.response.data) {
              console.log('Server validation error:', error.response.data);
            }
          });
      } else {
        api.post('/clients', payload)
          .then((res) => {
            console.log('Created contact:', res.data);
            if (addContact && typeof addContact === 'function') {
              addContact(res.data);
            }
            setFormInputs({
              firstName: '',
              lastName: '',
              phoneNumber: '',
              email: '',
              clientResources: '',
              realtorId: process.env.ADMIN_REALTOR_ID || '6552b44fd56a4b6eef501e53'
            });
            setView && setView('table');
            closeForm && closeForm();
          })
          .catch((error) => {
            console.error('Error creating contact:', error);
            if (error.response && error.response.data) {
              console.log('Server validation error:', error.response.data);
            }
          });
      }
    }
  };

  return (
    <div className="contact-form">
      <form onSubmit={handleFormSubmit}>
        <TextField
          required
          name="firstName"
          label="First Name"
          value={formInputs.firstName}
          onChange={handleInputChange}
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <TextField
          required
          name="lastName"
          label="Last Name"
          value={formInputs.lastName}
          onChange={handleInputChange}
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <TextField
          name="phoneNumber"
          label="Phone Number"
          value={formInputs.phoneNumber}
          onChange={handleInputChange}
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <TextField
          required
          type="email"
          name="email"
          label="E-mail"
          value={formInputs.email}
          onChange={handleInputChange}
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <TextField
          name="clientResources"
          label="Client Resources"
          value={formInputs.clientResources}
          onChange={handleInputChange}
          fullWidth
          variant="outlined"
          margin="normal"
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className="submit-btn"
        >
          {existingContact ? 'Update Contact' : 'Add Contact'}
        </Button>
      </form>
    </div>
  );
}

export default ContactForm;
